import axios from 'axios'
import { apis } from './apis.js'
import { getVm } from '../util'
import {commonParams} from '@/libs/commonParamsStore.js'
const qs = require('qs')
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL

axios.defaults.withCredentials = true
const instance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 5000,
})

const errorMap = {
  gum20210108121500:{
    19530001 : '用户不存在',
    19530007 : '用户不可用'
  }
}

const getRequestFun = (url, method) => {
  return async (data, cb = null, errCb = null) => {
    method = method.toLowerCase()
    let conf = {
      method,
      url
    }
    if (method === 'get') {
      conf['params'] = data
    } else {
      conf['headers'] = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      if (typeof data === "string") {
        conf['data'] = data
      } else {
        conf['data'] = qs.stringify(data)
      }
    }
    let msg = ''
    if (typeof cb === 'function') {
      // 回调方式
      instance(conf).then((res) => {
        let { data } = res
        if (data && typeof data === 'object') {
          data['data']['_origin'] = data
        }
        if (typeof data['errno'] != 'undefined' && data['errno'] == 0) {
          cb(res.data)
        } else {
          if(typeof data['errno'] != 'undefined' &&
              typeof errorMap[commonParams.state.dwd_appid] != 'undefined' &&
              typeof errorMap[commonParams.state.dwd_appid][data['errno']] != 'undefined'
          ){
             msg = errorMap[commonParams.state.dwd_appid][data['errno']]
          }else{
             msg = data.errmsg || '服务器错误'
          }

          if (errCb && typeof errCb == 'function') {
            if (errCb(data)) {
              getVm().$message({ type: 'error', message: msg })
            }
          } else {
            getVm().$message({ type: 'error', message: msg })
          }
        }

      }).catch(() => {
        throw new Error('网络错误')
      })
    } else {
      // 异步方式
      return new Promise((resolve, reject) => {
        instance(conf).then((res) => {
          let { data } = res
          if (data && typeof data === 'object') {
            data['data']['_origin'] = JSON.parse(JSON.stringify(data))
          }
          if (data && typeof data.errno != 'undefined' && data.errno == 0) {
            resolve(data.data)
          } else {
            if(typeof data['errno'] != 'undefined' &&
                typeof errorMap[commonParams.state.dwd_appid] != 'undefined' &&
                typeof errorMap[commonParams.state.dwd_appid][data['errno']] != 'undefined'
            ){
              msg = errorMap[commonParams.state.dwd_appid][data['errno']]
            }else{
              msg = data.errmsg || '服务器错误'
            }
            if (errCb && typeof errCb == 'function') {
              if (!errCb(data)) {
                getVm().$message({ type: 'error', message: msg })
              }
            } else {
              getVm().$message({ type: 'error', message: msg })
            }
          }
        }).catch(() => {
          // 请求出错了
          reject('网络错误')
        })
      })
    }
  }
}

let requests = {};
for (let api in apis) {
  const conf = apis[api]
  let url = '', method = 'get'
  if (typeof conf === 'string') {
    let confArr = conf.split(' ')
    if (confArr.length == 1) {
      url = confArr[0]
    } else if (confArr.length == 2) {
      url = confArr[1]
      method = confArr[0]
    } else {
      console.error(`${api}配置错误`)
      continue;
    }
  } else {
    console.error(`${api}配置错误`)
    continue;
  }

  requests[api] = getRequestFun(url, method)
}

export default requests